import { defineStore } from 'pinia'
import { computed, shallowRef } from 'vue'

import { useApiStore } from '@/stores/api'

import type { Environment } from '@policyfly/protobuf/pfbingo'

export const useEnvironmentStore = defineStore('environment', () => {
  const environmentsRef = shallowRef<Environment[]>([])
  const currentEnvironmentRef = shallowRef<Environment | null>(null)

  const apiStore = useApiStore()
  async function loadEnvironments (): Promise<void> {
    const response = await apiStore.listEnvironments()
    environmentsRef.value = response.environments
    if (environments.value.length && !currentEnvironment.value) {
      currentEnvironmentRef.value = environments.value
        .find((e) => e.name === 'local' || e.name === 'dev') ?? environments.value[0]!
    }
  }

  function setCurrentEnvironment (env: Environment): void {
    currentEnvironmentRef.value = env
  }

  const environments = computed(() => environmentsRef.value)
  const currentEnvironment = computed(() => currentEnvironmentRef.value)

  return {
    environments,
    currentEnvironment,
    loadEnvironments,
    setCurrentEnvironment,
  }
})
